import { BaseModel, fillOwnProperties, registerModel } from '~/shared/model'
import { isNumber, isUnknownObject, isString } from '~/shared/utils/guards'
import { formatSalary } from '~/shared/utils/helpers'
import { toApiDateTimeFormatHour } from '~/shared/utils/date'

export default class VacancyNewCardModel extends BaseModel {
  static override constructorName = 'VacancyNewCardModel'

  id: string = ''
  'position_name': string = ''
  'organization_value': string = ''
  'import_org_name': string = ''
  'workplace_value': string = ''
  'experience_value': string = ''
  'employment_value': string = ''
  'region_value': string = ''
  'housing_value': string = ''
  responsibilities: string = ''
  salary: number = 0
  'formatted_salary': string = ''
  updated: string = ''

  constructor(data?: unknown) {
    super(data)
    if (isUnknownObject(data)) {
      fillOwnProperties(this, data)

      if (isNumber(data.salary)) {
        this.formatted_salary =
          data.salary === 0 ? 'По договорённости' : `${formatSalary(data.salary.toString())} руб`
      }

      if (isString(data.updated)) {
        this.updated = 'Обновлено ' + toApiDateTimeFormatHour(data.updated)
      }

      if (isString(data.responsibilities)) {
        this.responsibilities = data.responsibilities.replace(/<\/?[^>]+>/g, '')
      }
    }
  }
}

registerModel(VacancyNewCardModel)
